import type { QuestionnaireEventNames } from '../questionnaire';

/**
 * What Get Matched calls each step of its funnel.
 *
 * Named for the feature rather than for the engine it runs on. The
 * questionnaire is a shape other features will reuse, and a shared
 * `Questionnaire*` name would file every future flow's rows under the same
 * `EVENT_TYPE` — so a Get Matched chart written today would quietly start
 * counting a feature that ships next year. The flow already separates them in
 * `Source`, but `EVENT_TYPE` is the filter most queries reach for first.
 *
 * `GetMatchedPromptImpression` belongs to the same family and is emitted
 * separately, by the prompts rather than by the flow — the prompt is seen by
 * people who never open anything, so it cannot come from the engine.
 */
export const GET_MATCHED_EVENT_NAMES: QuestionnaireEventNames = {
    opened: 'GetMatchedOpened',
    'auth-required': 'GetMatchedAuthRequired',
    'auth-completed': 'GetMatchedAuthCompleted',
    'step-viewed': 'GetMatchedStepViewed',
    'step-answered': 'GetMatchedStepAnswered',
    'step-back': 'GetMatchedStepBack',
    submitted: 'GetMatchedSubmitted',
    'submit-failed': 'GetMatchedSubmitFailed',
    abandoned: 'GetMatchedAbandoned',
};
